































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Converter, { Json2CsvOptions } from 'json-2-csv'
import { CvValue, EditorialProject } from '@/models'
import { ActionTypes } from '@/store/action-types'
import { CvValueUtils } from '@/utils/cv-value-utils'
import {
  CV_VALUE_COUNTRY, CV_VALUE_PRODUCTION_MODE, ROLE_SPECIAL, CV_VALUE_EDITORIAL_PROJECT_STATUS_ACTIVE,
  CV_VALUE_EDITORIAL_PROJECT_STATUS_NOT_ACTIVE, CV_VALUE_EDITORIAL_PROJECT_STATUS_PREP_PRODUCCION,
  CV_VALUE_EDITORIAL_PROJECT_STATUS_REV_CORRECCION, CV_VALUE_EDITORIAL_PROJECT_STATUS,
  CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT,
  ACCOUNT_ACTIONS_BUTTON_NEW_EDITORIAL_PROJECT,
  ACCOUNT_ACTIONS_BUTTON_EDIT_EDITORIAL_PROJECT
} from '@/utils/constants'
import { Utils } from '@/utils'
import _ from 'lodash'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  name: 'EditorialProjects',
  components: {
    EditorialProjectDetailModal: () => import('@/components/modals/editorialProjectDetailModal.vue'),
    EditorialProjectsTimeline: () => import('@/components/EditorialProjectsTimeline.vue'),
    UpsertEditorialProjectModal: () => import('@/components/modals/UpsertEditorialProjectModal.vue'),
    UpsertTracingProductionProjectModal: () => import('@/components/modals/UpsertTracingProductionProjectModal.vue')
  }
})
export default class EditorialProjects extends Vue {
  private CV_VALUE_PRODUCTION_MODE = CV_VALUE_PRODUCTION_MODE
  private CV_VALUE_EDITORIAL_PROJECT_STATUS = CV_VALUE_EDITORIAL_PROJECT_STATUS
  private CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT = CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT
  private ACCOUNT_ACTIONS_BUTTON_NEW_EDITORIAL_PROJECT = ACCOUNT_ACTIONS_BUTTON_NEW_EDITORIAL_PROJECT
  private ACCOUNT_ACTIONS_BUTTON_EDIT_EDITORIAL_PROJECT = ACCOUNT_ACTIONS_BUTTON_EDIT_EDITORIAL_PROJECT
  private ROLE_SPECIAL = ROLE_SPECIAL
  private EDITORIAL_PROJECT_FILTERS = 'editorialProjectFilters'
  private EDITORIAL_PROJECT_VIEW_MODE = 'editorialProjectViewMode'
  // List or calendar, remembered like the filters
  private viewMode: 'list' | 'calendar' = localStorage.getItem('editorialProjectViewMode') === 'calendar' ? 'calendar' : 'list'
  private utils = Utils

  private filters = {
    name: '',
    businessUnit: [],
    productionMode: [],
    country: [],
    status: [],
    yearStart: []
  }

  private years: Array<number> = Utils.getYearsForCampaign(2019)
  private countries: CvValue[] = []
  private businessUnits: CvValue[] = []
  private productionModes: CvValue[] = []
  private statuses: CvValue[] = []

  // Modals params
  private editorialProjectUpdate: EditorialProject | null = null
  private editorialProjectSelected: EditorialProject | null = null
  private editorialProjectForTracing: EditorialProject | null = null

  private fields = [
    { key: 'yearStart', label: `${this.$t('editorial_project_view.columns.year_start_field')}` },
    { key: 'name', label: `${this.$t('editorial_project_view.columns.name_field')}` },
    { key: 'status', label: `${this.$t('editorial_project_view.columns.info')}` },
    { key: 'id', label: `${this.$t('editorial_project_view.columns.tools')}` },
    { key: 'country', label: `${this.$t('editorial_project_view.columns.country_field')}` },
    { key: 'businessUnit', label: `${this.$t('editorial_project_view.columns.business_unit_field')}` },
    { key: 'organizationalLevels', label: `${this.$t('editorial_project_view.columns.organizational_levels_field')}` },
    { key: 'workedBrands', label: `${this.$t('editorial_project_view.columns.ww_brands')}` }
  ]

  async created() {
    this.loadFiltersFromStorage()
    await this.loadCountry()
    await this.loadBusinessUnit()
    await this.loadProductionModes()
    await this.loadStatuses()
    this.loadEditorialProjects()
  }

  get editorialProjects(): EditorialProject[] {
    let editorialProjects = this.$store.getters.editorialProjects
    editorialProjects = _.orderBy(editorialProjects, ['country', 'businessUnit', 'status', 'yearStart', 'name'], ['asc', 'asc', 'desc', 'desc', 'asc'])
    return editorialProjects
  }

  get editorialProjectsFiltered() {
    return this.editorialProjects
      .filter(this.filterName)
      .filter(this.filterBusinessUnit)
      .filter(this.filterCountry)
      .filter(this.filterProductionMode)
      .filter(this.filterStatus)
      .filter(this.filterYearStart)
  }

  @Watch('filters', { deep: true })
  onFiltersTableChanged() {
    this.updateFiltersStorage()
  }

  private filterName(item: EditorialProject) {
    if (this.filters.name && this.filters.name !== '') {
      if (Utils.normalizeText(item.name).includes(Utils.normalizeText(this.filters.name)) ||
        (item.commercialEditorialProjectName && Utils.normalizeText(item.commercialEditorialProjectName).includes(Utils.normalizeText(this.filters.name)))) {
        return item
      }
    } else {
      return item
    }
  }

  private filterBusinessUnit(item: EditorialProject) {
    if (this.filters.businessUnit.length > 0) {
      if (item.businessUnit && (this.filters.businessUnit as Array<string>).includes(item.businessUnit)) {
        return item
      }
    } else {
      return item
    }
  }

  private filterCountry(item: EditorialProject) {
    if (this.filters.country.length > 0) {
      if (item.country && (this.filters.country as Array<string>).includes(item.country)) {
        return item
      }
    } else {
      return item
    }
  }

  private filterProductionMode(item: EditorialProject) {
    if (this.filters.productionMode.length > 0) {
      if (item.productionMode && (this.filters.productionMode as Array<string>).includes(item.productionMode)) {
        return item
      }
    } else {
      return item
    }
  }

  private filterYearStart(item: EditorialProject) {
    if (this.filters.yearStart.length > 0) {
      if (item.yearStart && (this.filters.yearStart as Array<number>).includes(item.yearStart)) {
        return item
      }
    } else {
      return item
    }
  }

  private filterStatus(item: EditorialProject) {
    if (this.filters.status.length > 0) {
      if (item.status && (this.filters.status as Array<string>).includes(item.status)) {
        return item
      }
    } else {
      return item
    }
  }

  private getCvValueName(codeId: string, type: string = CV_VALUE_COUNTRY) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }

  private getCvValueIcon(codeId: string, type: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, type)
    if (!cvValue) {
      return ''
    }
    return cvValue.icon
  }

  private async loadEditorialProjects(force = false) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    await this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS, force)
    this.$store.commit(MutationTypes.SET_LOADING, false)
  }

  private async loadCountry() {
    this.countries.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY))
  }

  private async loadBusinessUnit() {
    this.businessUnits.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT))
  }

  private async loadProductionModes() {
    this.productionModes.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCTION_MODE))
  }

  private async loadStatuses() {
    this.statuses.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_STATUS))
  }

  private generateFileRootFolderUrl(editorialProject: EditorialProject) {
    if (!editorialProject.fileRootFolder || !editorialProject.localCode) {
      return ''
    }
    return encodeURI(`${process.env.VUE_APP_FUNBOX_URL}/apps/files/?dir=/${editorialProject.fileRootFolder}/${editorialProject.localCode}`)
  }

  private resetFilters() {
    Vue.set(this.filters, 'name', '')
    Vue.set(this.filters, 'country', [])
    Vue.set(this.filters, 'productionMode', [])
    Vue.set(this.filters, 'businessUnit', [])
    Vue.set(this.filters, 'status', [])
    Vue.set(this.filters, 'yearStart', [])
  }

  private loadFiltersFromStorage() {
    const filters = JSON.parse(localStorage.getItem(this.EDITORIAL_PROJECT_FILTERS) || '{}')

    if (filters.name) {
      this.filters.name = filters.name
    }

    if (filters.businessUnit) {
      this.filters.businessUnit = filters.businessUnit
    }

    if (filters.productionMode) {
      this.filters.productionMode = filters.productionMode
    }

    if (filters.country) {
      this.filters.country = filters.country
    }

    if (filters.status) {
      this.filters.status = filters.status
    }

    if (filters.yearStart) {
      this.filters.yearStart = filters.yearStart
    }
  }

  private updateFiltersStorage() {
    const filters: any = {}

    if (this.filters.name && this.filters.name !== '') {
      filters.name = this.filters.name
    }

    if (this.filters.businessUnit && this.filters.businessUnit.length > 0) {
      filters.businessUnit = this.filters.businessUnit
    }

    if (this.filters.productionMode && this.filters.productionMode.length > 0) {
      filters.productionMode = this.filters.productionMode
    }

    if (this.filters.country && this.filters.country.length > 0) {
      filters.country = this.filters.country
    }

    if (this.filters.status && this.filters.status.length > 0) {
      filters.status = this.filters.status
    }

    if (this.filters.yearStart && this.filters.yearStart.length > 0) {
      filters.yearStart = this.filters.yearStart
    }

    localStorage.setItem(this.EDITORIAL_PROJECT_FILTERS, JSON.stringify(filters))
  }

  private async downloadCsv() {
    const options: Json2CsvOptions = {
      delimiter: { field: ';' },
      emptyFieldValue: '-',
      keys: [
        { field: 'yearStart', title: `${this.$t('editorial_project_view.columns.year_start_field')}` },
        { field: 'id', title: `${this.$t('editorial_project_view.columns.code_field')}` },
        { field: 'name', title: `${this.$t('editorial_project_view.columns.name_field')}` },
        { field: 'commercialEditorialProject', title: `${this.$t('editorial_project_view.columns.commercial_editorial_project_code_field')}` },
        { field: 'country', title: `${this.$t('editorial_project_view.columns.country_field')}` },
        { field: 'businessUnit', title: `${this.$t('editorial_project_view.columns.business_unit_field')}` },
        { field: 'productionMode', title: `${this.$t('editorial_project_view.columns.production_mode_field')}` },
        { field: 'organizationalLevel1', title: `${this.$t('editorial_project_view.columns.organizational_level_1_field')}` },
        { field: 'organizationalLevel2', title: `${this.$t('editorial_project_view.columns.organizational_level_2_field')}` },
        { field: 'useSharepoint', title: `${this.$t('editorial_project_view.columns.use_sharepoint_field')}` },
        { field: 'useAnalytics', title: `${this.$t('editorial_project_view.columns.use_analytics_field')}` },
        { field: 'localCode', title: `${this.$t('editorial_project_view.columns.local_code_field')}` },
        { field: 'fileRootFolder', title: `${this.$t('editorial_project_view.columns.file_root_folder_field')}` },
        { field: 'wwBrands', title: `${this.$t('editorial_project_view.columns.ww_brands')}` }
      ]
    }
    const csvdata = await Converter.json2csvAsync(this.editorialProjectsFiltered, options)
    Utils.downloadCsv(csvdata, `editorial-projects-${new Date().getTime()}.csv`)
  }

  private getTitleProductionProject(status: string) {
    switch (status) {
      case CV_VALUE_EDITORIAL_PROJECT_STATUS_ACTIVE:
        return this.$t('editorial_project_view.production_editorial.active')
      case CV_VALUE_EDITORIAL_PROJECT_STATUS_NOT_ACTIVE:
        return this.$t('editorial_project_view.production_editorial.not_active')
      case CV_VALUE_EDITORIAL_PROJECT_STATUS_PREP_PRODUCCION:
        return this.$t('editorial_project_view.production_editorial.preparation_production')
      case CV_VALUE_EDITORIAL_PROJECT_STATUS_REV_CORRECCION:
        return this.$t('editorial_project_view.production_editorial.review_correction')
      default:
        return this.$t('editorial_project_view.production_editorial.not_active')
    }
  }

  private setViewMode(viewMode: 'list' | 'calendar') {
    this.viewMode = viewMode
    localStorage.setItem(this.EDITORIAL_PROJECT_VIEW_MODE, viewMode)
  }

  private setEditorialProjectDetailModal(editorialProject: EditorialProject) {
    this.editorialProjectSelected = Object.assign({}, editorialProject)
    this.$bvModal.show('editorialProjectDetailModal')
  }

  private brandsUsedAndNotConfigured(brandsConfiguredString: string, brandsUsed: string[]) {
    const brandsCondiguredArray = brandsConfiguredString ? brandsConfiguredString.split(',') : []
    const brandsUsedArray = brandsUsed

    return brandsUsedArray.filter(item => !brandsCondiguredArray.includes(item))
  }

  private brandsConfiguredAndNotUsed(brandsConfiguredString: string, brandsUsed: string[]) {
    const brandsCondiguredArray = brandsConfiguredString ? brandsConfiguredString.split(',') : []
    const brandsUsedArray = brandsUsed

    return brandsCondiguredArray.filter(item => !brandsUsedArray.includes(item))
  }

  private getSharepointUrl(editorialProject: EditorialProject) {
    return editorialProject.sharepointFolderUrl + 'Documentos compartidos/' + editorialProject.name
  }

  setModalCreateEditorialProject() {
    this.editorialProjectUpdate = Object.assign({}, null)
    this.$bvModal.show('UpsertEditorialProjectModal')
  }

  setModalUpdateEditorialProject(editorialProject: EditorialProject) {
    this.editorialProjectUpdate = Object.assign({}, editorialProject)
    this.$bvModal.show('UpsertEditorialProjectModal')
  }

  private editorialProjectSaved() {
    this.loadEditorialProjects(true)
  }

  setModalTracingProductionProject(editorialProject: EditorialProject) {
    this.editorialProjectForTracing = Object.assign({}, editorialProject)
    this.$bvModal.show('upsertTracingProductionProjectModal')
  }
}
